import { REPORT_QUESTION_TYPE, type MetricQuestion } from './types';

export const isMultipleChoice = (question: MetricQuestion): boolean =>
  question.type === REPORT_QUESTION_TYPE.Multiselect ||
  (question.type === REPORT_QUESTION_TYPE.Select && Number(question.selectedRange?.split('-').pop()) > 1);

export const scaleOptionValue = (optionIndex: number, optionScores: (number | null)[]): number | undefined =>
  optionScores[optionIndex] ?? undefined;
